/**
 * @generated SignedSource<<6ee58581ca73bfcc1c54da15ab98a235>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityHeaderFragment_department$data = {
  readonly club: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityFiltersModal_department" | "useGetDepartmentAvailabilityFilterBarValues_department">;
  readonly " $fragmentType": "DepartmentAvailabilityHeaderFragment_department";
};
export type DepartmentAvailabilityHeaderFragment_department$key = {
  readonly " $data"?: DepartmentAvailabilityHeaderFragment_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityHeaderFragment_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilityHeaderFragment_department",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetDepartmentAvailabilityFilterBarValues_department"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityFiltersModal_department"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FacilityLogoFragment_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "522f399e1d7b287c3f8f5f09678f702d";

export default node;
